module.exports = __webpack_public_path__ + "media/anim2.e040b6d6.mp4";